document.addEventListener('DOMContentLoaded', function() {
  const searchSuggestions = document.querySelector('search-suggestions');
  const suggestionsContainer = document.querySelector('.search-suggestions-container');
  
  if (searchSuggestions && suggestionsContainer) {
    suggestionsContainer.appendChild(searchSuggestions);
  }
});

if (!customElements.get('search-suggestions')) {
  class SearchSuggestions extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.suggestionsContainer = document.querySelector('.search-suggestions-container');
      
      if (this.searchInput) {
        this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
        this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
      }

      this.showDefaultSearchTerms();
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort();
          this.searchSuggestionsAbortController = null;
        }

        this.showDefaultSearchTerms();
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort();
      }
      this.searchSuggestionsAbortController = new AbortController();

      fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(terms)}&section_id=search-suggestions`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          if (results && results.firstElementChild) {
            this.insertAdjacentElement('beforeend', results.firstElementChild);
          } else {
            this.showDefaultSearchTerms();
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            return; // aborted
          }
          this.showDefaultSearchTerms();
          console.error('Fetch error:', error);
        });
    }

    showDefaultSearchTerms() {
      const defaultTerms = [
        'The Kate Bumpsuit',
        'The Legging',
        'The Lucy Bumpsuit',
        'The Stevie Bumpsuit',
        'The Monica Dress'
      ];

      this.innerHTML = ''; // Clear any existing content
      const wrapper = document.createElement('div');
      wrapper.className = 'search-suggestions';

      const heading = document.createElement('div');
      heading.className = 'search-suggestions__heading';
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
      heading.textContent = 'Suggestions';
      wrapper.appendChild(heading);

      const list = document.createElement('ul');
      list.className = 'search-suggestions__results-list';

      defaultTerms.forEach(term => {
        const item = document.createElement('li');
        item.className = 'search-suggestions__list-item';
        const link = document.createElement('a');
        link.className = 'search-suggestions__item';
        link.textContent = term;
        link.href = `https://www.bumpsuit.co/search?q=${encodeURIComponent(term)}`;
        item.appendChild(link);
        list.appendChild(item);
      });

      wrapper.appendChild(list);
      this.appendChild(wrapper);

      if (this.suggestionsContainer) {
        this.suggestionsContainer.innerHTML = '';
        this.suggestionsContainer.appendChild(this);
      }
    }
  }

  window.customElements.define('search-suggestions', SearchSuggestions);
}


